import { render, staticRenderFns } from "./EquationBar.vue?vue&type=template&id=56a307aa"
import script from "./EquationBar.vue?vue&type=script&lang=js"
export * from "./EquationBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../frontend-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports